"use client";

import { useEffect } from "react";
import { CalendarX2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

export default function TerminFehler({ error, retry }: { error: unknown; retry: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);
  const digest = error instanceof Error ? (error as Error & { digest?: string }).digest : undefined;
  return (
    <EmptyState
      icon={CalendarX2}
      title="Dieser Teil des Termins ließ sich nicht laden"
      description={digest ? `Fehlerkennung ${digest} — bitte bei der Ansichtssache melden, wenn es bleibt.` : "Bitte noch einmal versuchen."}
      action={<Button onClick={() => retry()}>Noch einmal</Button>}
    />
  );
}
